export default __webpack_public_path__ + "static/media/arrowRight.b9399d96.svg";